import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const solutions = [{
  title: 'Planificación Anual Completa',
  desc: 'Una estructura clara de sesión para no arrancar "a las apuradas". Organizás tus 40 semanas de clase con orden y coherencia.'
}, {
  title: 'Progresiones por Nivel',
  desc: 'Evitás saltos riesgosos: las tareas van de lo simple a lo específico en los 4 aparatos, para que cada etapa tenga sentido técnico.'
}, {
  title: 'Gestión de Grupos Mixtos',
  desc: 'Criterios para entrenar con lógica de estaciones diferenciadas, permitiendo que todos progresen sin que el profe pierda el control.'
}, {
  title: 'Evaluación y Gamificación',
  desc: 'Registrás avances y entregás logros de forma ordenada. Motivás a tus alumnos y mostrás resultados profesionales a las familias.'
}];
export function Solution() {
  return <section className="w-full bg-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-202">
      <div className="max-w-5xl mx-auto" data-id="element-203">
        <div className="text-center mb-16" data-id="element-204">
          <span className="text-primary font-bold tracking-widest text-sm uppercase mb-3 block" data-id="element-205">
            La solución
          </span>
          <h2 className="text-3xl sm:text-4xl font-heading font-black text-navy mb-4" data-id="element-206">
            ¿Qué vas a encontrar adentro?
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-207">
            Todo lo que necesitás, en un solo lugar. Más de 360 páginas de
            sistema puro.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-208">
          {solutions.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-gray-100 flex gap-4 hover:shadow-md transition-shadow" data-id="element-209">
              <div className="bg-primary/10 p-2 rounded-lg h-fit shrink-0" data-id="element-210">
                <CheckCircle2 className="w-6 h-6 text-primary" data-id="element-211" />
              </div>
              <div data-id="element-212">
                <h3 className="font-bold text-navy text-lg mb-2" data-id="element-213">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-214">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}